import FIELD_TYPE from '../../constants/fieldType';
import { ACTION_VALUES } from '../../constants/GlPostingConstants';

export { ACTION_VALUES };

export const ROUTES = {
  TAB_QUERY_PARAM: 'selectedTab',
  TAB_QUERY_OPEN: '1',
  TAB_QUERY_APPROVED: '2',
  QUERY_STRING_OPEN: '?selectedTab=1',
  QUERY_STRING_APPROVED: '?selectedTab=2',
};

export const WEEKLY_GL_POSTING_TEXT = {
  SEARCH_PLACEHOLDER_OPEN: 'Search by Location',
  SEARCH_PLACEHOLDER_APPROVED: 'Search',
  EMPTY_STATE_OPEN: 'No Open GL Postings Found',
  EMPTY_STATE_APPROVED: 'No Approved GL Postings Found',
  NO_RESULTS: 'No results found.',
  NOT_AVAILABLE: FIELD_TYPE.NOT_APPLICABLE,
};

export const LIST_LAYOUT = {
  LOADING_SPINNER_HEIGHT: 300,
};

export const LABELS = {
  WEEK: 'DATE RANGE',
  POSTING_DATE: 'Posting Date',
  PRODUCT_TYPE: 'X3 Product Name',
  CURRENCY: 'Currency',
  CREATED_BY: 'Created By',
  SELECTED_SUBLOCATIONS: 'Selected Sublocations',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  SUBLOCATIONS: 'Sublocations',
  SELECT_PRODUCT: 'Select X3 Product Name',
  SELECT_CURRENCIES: 'Select Currencies',
  NO_ACTIVE_CURRENCIES: 'No active currencies found',
  SELECT_SUBLOCATIONS: 'Select Sublocations',
  SEARCH_SUBLOCATIONS: 'Search sublocations...',
  SELECT_ALL: 'Select All',
  DESELECT_ALL: 'Deselect All',
  APPLY: 'Apply',
  APPLYING: 'Applying...',
  APPLY_DISABLED_SELECT_PRODUCT: 'Select an X3 product name to continue',
  APPLY_DISABLED_SELECT_CURRENCY: 'Select one or more currencies to continue',
  APPLY_DISABLED_SELECT_WEEK: 'Select a date range to continue',
  APPROVE_DISABLED_SELECT_POSTING_DATE: 'Select a posting date to continue',
  APPLY_DISABLED_SELECT_SUBLOCATION: 'Select at least one sublocation',
  APPLY_DISABLED_LOADING: 'Loading sublocations...',
  APPLY_DISABLED_FETCHING_FEEDS: 'Fetching feed source summary...',
  APPLY_DISABLED_DATE_MISMATCH: 'End date differs across selected sublocations.',
  APPLY_DISABLED_GENERIC: 'Sublocation selection is disabled',
  DATE_END_DATE_MISMATCH_WARNING: 'End date differs across selected sublocations.',
  DATE_END_DATE_MISMATCH_ACTION: '',
  DATE_END_DATE_MIXED_WARNING: 'End date differs across selected sublocations.',
  DATE_END_DATE_MIXED_ACTION: '',
  MISSING_END_DATE: '-',
  ALREADY_POSTED: 'Already posted',
  NO_SUBLOCATIONS_FOUND: 'No sublocations found',
  LOADING_SUBLOCATIONS: 'Loading sublocations...',
  LOADING: 'Loading...',
  NOT_AVAILABLE: WEEKLY_GL_POSTING_TEXT.NOT_AVAILABLE,
  SHOWING_COUNT: (visible, total) => `Showing ${visible} of ${total}`,
  SHOW_MORE: (count) => `+ ${count} more`,
  SHOW_LESS: 'Show less',
};

export const DEFAULTS = {
  EMPTY_STRING: '',
  EMPTY_ARRAY: [],
  ZERO: 0,
};

export const LAYOUT = {
  GRID_SPACING: 2,
  HEADER_PADDING_X: 3,
  HEADER_PADDING_TOP: 2,
  HEADER_PADDING_BOTTOM: 0,
  SUBLOCATION_PADDING_X: 3,
  SUBLOCATION_PADDING_TOP: 1.5,
  SUBLOCATION_PADDING_BOTTOM: 2,
  ACTION_BUTTONS_PADDING_X: 3,
  ACTION_BUTTONS_PADDING_Y: 2,
};

export const DROPDOWN_CONFIG = {
  SUBLOCATION_MENU_MAX_HEIGHT: 600,
  SUBLOCATION_MENU_WIDTH: 420,
  INITIAL_ITEMS_TO_SHOW: 50,
  ITEMS_PER_LOAD: 20,
  SCROLL_THRESHOLD: 200,
  GROUP_INITIAL_VISIBLE_ITEMS: 6,
};

export const STYLE_CONSTANTS = {
  APPROVAL_BUTTON_MIN_HEIGHT: 36,
  MENU_ITEM_MIN_HEIGHT: 38,
  POPOVER_MAX_HEIGHT: 460,
  WARNING_PANEL_MAX_HEIGHT: 200,
  SUBLOCATION_MENU_BORDER_RADIUS: 10,
  SELECTED_POPOVER_MIN_WIDTH: 460,
  SELECTED_POPOVER_MAX_WIDTH: 640,
};

export const DATE_CONSTRAINTS = {
  START_DATE_MIN: '2026-01-01',
  NO_LAST_POSTING_MIN_DATE: '2026-01-01',
  DISPLAY_DATE_FORMAT: 'MM/DD/YYYY',
};

export const ERROR_MODAL_STATUSES = [400, 401, 403, 500, 502, 'PARSING_ERROR'];

export const FEED_SOURCES = [
  { key: 'nayax', label: 'Nayax' },
  { key: 'cardTransactions', label: 'SeedLive' },
  { key: 'seedlive', label: 'SeedLive' },
  { key: 'intercard', label: 'Intercard' },
];

export const APPROVED_POSTING_FALLBACK_FEED_SOURCE_DATA = Array.from(
  FEED_SOURCES.reduce((acc, { label }) => {
    if (acc.has(label)) return acc;
    acc.set(label, {
      feedSource: label,
      cash: 0,
      credit: 0,
      refund: 0,
      total: 0,
    });
    return acc;
  }, new Map()).values(),
);

export const GRID_SIZES = {
  PRODUCT_TYPE: { xs: 12, sm: 6, md: 3 },
  START_DATE: { xs: 12, sm: 6, md: 3 },
  END_DATE: { xs: 12, sm: 6, md: 3 },
  SUBLOCATION: { xs: 12, sm: 6, md: 3 },
  APPLY_BUTTON: { xs: 12, sm: 6, md: 2 },
};

export const TEST_IDS = {
  PRODUCT_TYPE_SELECT: 'product-type-select',
  CURRENCY_SELECT: 'currency-select',
  START_DATE_PICKER: 'start-date-picker',
  END_DATE_PICKER: 'end-date-picker',
  POSTING_DATE_PICKER: 'posting-date-picker',
  SUBLOCATION_SELECT: 'sublocation-select',
  APPLY_BUTTON: 'apply-sublocation-btn',
};

export const UI_TEXT = {
  APPROVED_POSTING: 'Approved Posting',
  START_NEW_POSTING: 'Start new posting',
  VIEW_APPROVED_LIST: 'View approved list',
  POSTED_BY: 'Posted by',
  POSTED_ON: 'on',
  POSTING_SUCCESS_PREFIX: 'The posting for',
  POSTING_SUCCESS_MIDDLE: 'for',
  POSTING_SUCCESS_SUFFIX: 'is done successfully.',
  POSTING_SUCCESS_TIMER: 'This message will close in',
  TOTAL: 'Total',
  ALL_AMOUNTS_USD: 'All amounts are in USD',
  OPEN_POSTING_HELP_TITLE: 'How to proceed',
  OPEN_POSTING_HELP_NOTE:
    'If dates are disabled or a warning appears, adjust sublocations or date range until the warning clears.',
};

export const OPEN_POSTING_CHECKLIST = [
  { key: 'product', label: 'Select X3 Product Name' },
  { key: 'currency', label: 'Select one or more Currency' },
  { key: 'sublocations', label: 'Select one or more Sublocations' },
  { key: 'dates', label: 'Choose Start Date, End Date and Posting Date' },
  { key: 'apply', label: 'Click Apply to load Feed Source summary' },
  { key: 'approve', label: 'Review totals, then click Approve' },
];

export const ACTION_LABELS = {
  ADD_NEW_ROW: 'Add New Row',
  APPROVE: 'Approve',
  TRY_AGAIN: 'Try Again',
};

export const A11Y_TEXT = {
  ADD_NEW_ROW: 'Add new row',
  APPROVE_POSTING: 'Approve posting',
};

export const MODAL_CONFIG = {
  LOADING_WIDTH: '395px',
  LOADING_SPINNER_HEIGHT: LIST_LAYOUT.LOADING_SPINNER_HEIGHT,
  SUCCESS_TIMER_SECONDS: 5,
};

export const ICON_SIZES = {
  SUCCESS: '4rem',
};

export const FEED_SOURCE_TEXT = {
  EMPTY_STATE: 'No feed source data available for the selected criteria.',
  LOADING_STATE: 'Fetching feed source summary. Please wait...',
};
